import {  createTheme, responsiveFontSizes } from "@mui/material/styles";

let tynoTheme = createTheme({
    palette: {
        primary: {
            main: '#367649',
            light: '#F6F4E9', //light blue for bg
            contrastText: '#fff',
        },
        secondary: {
            main: '#000000',
            light: '#888888', //light gray for subtitle
            contrastText: '#fff',
        }
        },
        typography:{
        button: {
            textTransform: 'none'
        },
        body1: {
            fontSize: 15,
            fontFamily: "inherit"
        },
        body2: {
            fontSize: 14,
            fontWeight: 400
        },
        subtitle1: {
            fontSize: 13,
        },
        subtitle2: {
            
        }
        },

});

tynoTheme = responsiveFontSizes(tynoTheme);

export default tynoTheme;